import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Capture the PWA install prompt as early as possible: Chrome fires
// `beforeinstallprompt` once, often before the customer logs in and the install
// CTA mounts. Stash it globally so usePwaInstall can surface it afterwards.
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__deferredInstallPrompt = e;
    window.dispatchEvent(new Event("vt_install_prompt_ready"));
  });
  window.addEventListener("appinstalled", () => {
    window.__deferredInstallPrompt = null;
  });
}


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();
